import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import Button from 'flarum/common/components/Button';
import EditListingModal from './components/EditListingModal';
function isActive(discussion) {
  return (discussion.listingStatus() || 'active') === 'active';
}
export default function addListingControls() {
  const Controls = DiscussionControls;
  extend(DiscussionControls, 'userControls', function (items, discussion) {
    if (!discussion.isClassifieds()) return;
    if (discussion.canMarkListingSold()) {
      items.add('markListingSold', m(Button, {
        icon: isActive(discussion) ? 'fas fa-check-circle' : 'fas fa-undo',
        onclick: () => Controls.markListingSoldAction.call(discussion)
      }, app.translator.trans(isActive(discussion) ? 'flarum-classifieds.forum.discussion_controls.mark_sold_button' : 'flarum-classifieds.forum.discussion_controls.mark_active_button')), 90);
    }
    if (discussion.canBumpListing() && isActive(discussion)) {
      items.add('bumpListing', m(Button, {
        icon: "fas fa-arrow-up",
        onclick: () => Controls.bumpListingAction.call(discussion)
      }, app.translator.trans('flarum-classifieds.forum.discussion_controls.bump_button')), 80);
    }
    if (discussion.canEditListing()) {
      items.add('editListing', m(Button, {
        icon: "fas fa-tag",
        onclick: () => Controls.editListingAction.call(discussion)
      }, app.translator.trans('flarum-classifieds.forum.discussion_controls.edit_listing_button')), 85);
    }
  });
  Controls.markListingSoldAction = function () {
    const next = isActive(this) ? 'sold' : 'active';
    return this.save({
      listingStatus: next
    }).then(() => {
      if (app.current.matches(DiscussionPage)) {
        app.current.get('stream').update();
      }
      m.redraw();
    });
  };
  Controls.bumpListingAction = function () {
    return this.save({
      bumpListing: true
    }).then(() => {
      if (app.current.matches(DiscussionPage)) {
        app.current.get('stream').update();
      }
      m.redraw();
    });
  };
  Controls.editListingAction = function () {
    app.modal.show(EditListingModal, {
      discussion: this
    });
  };
}